import { Plus, RotateCcw, UserPlus2 } from "lucide-react";

interface B2bUsersToolbarProps {
  onAddSystem: () => void;
  onAddActor: () => void;
  onReset: () => void;
  nodeCount: number;
  edgeCount: number;
}

export function B2bUsersToolbar({
  onAddSystem,
  onAddActor,
  onReset,
  nodeCount,
  edgeCount,
}: B2bUsersToolbarProps) {
  return (
    <div
      data-slot="b2b-users-toolbar"
      className="font-data pointer-events-auto flex items-center gap-1.5 rounded-lg border border-[oklch(0.91_0.008_240)] bg-white/95 p-1 shadow-sm backdrop-blur"
    >
      <button
        type="button"
        onClick={onAddSystem}
        title="Add a new system / component"
        className="inline-flex items-center gap-1.5 rounded-md bg-[oklch(0.55_0.16_55)] px-2.5 py-1.5 text-[11px] font-bold tracking-tight text-white transition-colors hover:bg-[oklch(0.5_0.18_55)]"
      >
        <Plus className="size-3.5" />
        Component
      </button>
      <button
        type="button"
        onClick={onAddActor}
        title="Add a new actor (person / boundary)"
        className="text-foreground/80 hover:bg-foreground/5 inline-flex items-center gap-1.5 rounded-md border border-[oklch(0.91_0.008_240)] bg-white px-2.5 py-1.5 text-[11px] font-semibold tracking-tight transition-colors"
      >
        <UserPlus2 className="size-3.5" />
        Actor
      </button>
      <span className="text-muted-foreground/70 mx-1 text-[10px] tracking-wide">
        {nodeCount}n · {edgeCount}e
      </span>
      <button
        type="button"
        onClick={onReset}
        title="Reset stage to the seed graph"
        className="text-muted-foreground hover:text-foreground hover:bg-foreground/5 inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[11px] font-semibold tracking-tight transition-colors"
      >
        <RotateCcw className="size-3.5" />
        Reset stage
      </button>
    </div>
  );
}
